<template>
	<footer>
		<ul class="icons">
			<li><a href="http://github.com/samweru" class="icon fa-github"><span class="label">Github</span></a></li>
			<li><a href="http://twitter.com/samiweru" class="icon fa-twitter"><span class="label">Twitter</span></a></li>
			<li><a href="mailto:samweru@gmail.com" class="icon fa-envelope"><span class="label">Email</span></a></li>
		</ul>
	</footer>
</template>